import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import OutlinedInput from '@mui/material/OutlinedInput';

import {
  getPasswordNotification,
  getValidateToken
} from 'store/recoverAccount-actions';

import Loading from 'uI/Loading/Loading';
import classes from './RecoverAccountThirdStep.module.css';

const RecoverAccountThirdStep = props => {
  const { t } = useTranslation(['recoverAccount']);
  const [isLoading, setIsLoading] = useState(false);
  const { register, handleSubmit, watch } = useForm();
  const [userCode] = watch(['userCode']);
  const dispatch = useDispatch();
  const recoverAccountData = useSelector(
    state => state.recoverAccountInfo
  );

  useEffect(() => {
    if (recoverAccountData.checkToken[0] === 'noToken') {
      setIsLoading(false);
    }
  }, [recoverAccountData]);

  useEffect(() => {
    props.changeErrorMessage();
  }, [userCode]);

  const onSubmit = async data => {
    setIsLoading(true);
    props.tokenHandler(data.userCode);
    dispatch(getValidateToken(data.userCode, props.alias));
  };

  const resendCodeHandler = () => {
    dispatch(getPasswordNotification(props.alias));
  };

  return (
    <>
      <form
        className={classes.formContainer}
        onSubmit={handleSubmit(onSubmit)}
      >
        <OutlinedInput
          className={classes.textField}
          {...register('userCode')}
          placeholder={t('code')}
        />
        <Button
          className={classes.resendCodeBtn}
          onClick={resendCodeHandler}
        >
          {t('resend_code')}
        </Button>
        {!isLoading ? (
          <aside className={classes.btnContainer}>
            <Button
              className={classes.searchBtn}
              variant="contained"
              disabled={!userCode}
              type="submit"
            >
              {t('search')}
            </Button>
          </aside>
        ) : (
          <Loading />
        )}
      </form>
      <p className={classes.complementaryText}>{t('extra_help')}</p>
      <p className={classes.complementaryText}>
        {t('you_can_go')}{' '}
        <span>
          {' '}
          <a
            className={classes.helpCenterBtn}
            href="http://ayuda.mayahii.com/"
            target="_blank"
            rel="noreferrer"
          >
            {' '}
            {t('help_center')}
          </a>
        </span>
      </p>
    </>
  );
};

RecoverAccountThirdStep.propTypes = {
  // eslint-disable-next-line react/require-default-props
  alias: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  tokenHandler: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  changeErrorMessage: PropTypes.func
};

export default RecoverAccountThirdStep;
